// import { useMutation, useQueryClient } from 'react-query';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  ParticipantLogInAndSecurityService,
  // eslint-disable-next-line camelcase
  type Wealthlane_Shared_Hosting_Dtos_ParticipantLogInSecurity_ParticipantLogInSecurityResponseDto,
} from '../../services/wealthlane-identity-services';
import AuthService from '../../services/authService';

const usePostChangePassword = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  // eslint-disable-next-line camelcase
  | Wealthlane_Shared_Hosting_Dtos_ParticipantLogInSecurity_ParticipantLogInSecurityResponseDto
  | undefined,
  unknown,
  void,
  unknown
> => {
  const queryClient = useQueryClient();
  const authService = new AuthService();

  return useMutation(
    async (payload) => {
      return await handleRequest(
        ParticipantLogInAndSecurityService.postApiIdentityApiAppParticipantLogInAndSecurityChangeParticipantLogInPassword(
          payload as any
        )
      );
    },

    {
      onSuccess: async (
        response: // eslint-disable-next-line camelcase
        | Wealthlane_Shared_Hosting_Dtos_ParticipantLogInSecurity_ParticipantLogInSecurityResponseDto
          | undefined
      ) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message='Password updated.' />);
          await queryClient.invalidateQueries('getParticipantAndLogin');
          closeModal();
          void authService.logout({ force: true });
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostChangePassword;
